function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon/content/create_24px");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 9.08 0 10 0.92 10 9.98 0.94 9.06 0.02"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,11.25 L0,15 L3.75,15 L14.81,3.94 L11.06,0.19 L0,11.25 Z M2.92,13 L2,13 L2,12.08 L11.06,3.02 L11.98,3.94 L2.92,13 Z",
  id: "path-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.71,2.63 L3.37,0.29 C3.17,0.09 2.92,0 2.66,0 C2.4,0 2.15,0.1 1.96,0.29 L0.13,2.12 L3.88,5.87 L5.71,4.04 C6.1,3.65 6.1,3.02 5.71,2.63 Z",
  id: "path-5"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "6.0-Tech-Report---Report",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/content/create_24px",
  transform: "translate(-3.000000, -3.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u21B3-Light-Color",
  transform: "translate(5.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Mask",
  opacity: 0.3,
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u2731-/-Color-/-Icons-/-Black-/-Disabled",
  mask: "url(#mask-2)",
  fill: "#000000",
  fillOpacity: 0.38
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 101,
  height: 101
}))), /*#__PURE__*/React.createElement("g", {
  id: "\\u21B3-Dark-Color",
  transform: "translate(3.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Mask",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u2731-/-Color-/-Icons-/-Black-/-Inactive",
  mask: "url(#mask-4)",
  fill: "#000000",
  fillOpacity: 0.54
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 101,
  height: 101
}))), /*#__PURE__*/React.createElement("g", {
  id: "\\u21B3-Dark-Color",
  transform: "translate(15.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Mask",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u2731-/-Color-/-Icons-/-Black-/-Inactive",
  mask: "url(#mask-6)",
  fill: "#000000",
  fillOpacity: 0.54
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 101,
  height: 101
})))));

var SvgCacEdit = function SvgCacEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCacEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cac_edit.6beb94c3.svg";
export { ForwardRef as ReactComponent };